<section class="category-area bg-top-center space" data-bg-src="assets/img/bg/category_bg_1.png">
    <div class="container th-container">
        <div class="title-area mb-60 text-center">
            <span class="sub-title text-anime-style-2">Our Key Features</span>
            <h2 class="sec-title text-anime-style-3">Complete IT Solutions Provider</h2>
        </div>
        <div class="swiper th-slider categorySlider" id="categorySlider1"
            data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"576":{"slidesPerView":"1"},"768":{"slidesPerView":"2"},"992":{"slidesPerView":"3"},"1200":{"slidesPerView":"3"},"1400":{"spaceBetween":45,"slidesPerView":"5"}}}'>
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="category-card single">
                        <div class="box-img global-img">
                            <img src="assets/img/category/category_1_1.jpg" alt="Web Development" />
                        </div>
                        <h3 class="box-title"><a routerLink="/website-development">Web Development</a></h3>
                        <p class="sec-text">We build fast, modern, and scalable web development solutions.</p>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="category-card single">
                        <div class="box-img global-img">
                            <img src="assets/img/category/category_1_2.jpg" alt="UX/UI Design" />
                        </div>
                        <h3 class="box-title"><a routerLink="/design">UX/UI Design</a></h3>
                        <p class="sec-text">Crafting seamless, intuitive interfaces for exceptional user experiences.
                        </p>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="category-card single">
                        <div class="box-img global-img">
                            <img src="assets/img/category/category_1_3.jpg" alt="Mobile Development" />
                        </div>
                        <h3 class="box-title"><a routerLink="/mobile-development">App Development</a></h3>
                        <p class="sec-text">Custom web applications tailored to streamline your business and growth.</p>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="category-card single">
                        <div class="box-img global-img">
                            <img src="assets/img/category/category_1_6.jpg" alt="AI Assisted Integrations" />
                        </div>
                        <h3 class="box-title"><a routerLink="/services">AI Assisted Integrations</a></h3>
                        <p class="sec-text">AI Assisted Integrations streamline workflows with smart, automated
                            connectivity solutions.</p>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="category-card single">
                        <div class="box-img global-img">
                            <img src="assets/img/category/category_1_2.jpg" alt="SEO Services" />
                        </div>
                        <h3 class="box-title"><a routerLink="/seo-services">SEO Services</a></h3>
                        <p class="sec-text">Boost your online visibility with expert SEO services today.</p>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="category-card single">
                        <div class="box-img global-img">
                            <img src="assets/img/category/category_1_1.jpg" alt="Maintenance and Updates" />
                        </div>
                        <h3 class="box-title"><a routerLink="/maintenance-and-updates">Maintenance and Updates</a></h3>
                        <p class="sec-text">Regular maintenance ensures performance, security, and smooth user
                            experience.</p>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="category-card single">
                        <div class="box-img global-img">
                            <img src="assets/img/category/category_1_5.jpg" alt="iOS Development" />
                        </div>
                        <h3 class="box-title"><a routerLink="/ios-development">iOS Development</a></h3>
                        <p class="sec-text">Expert iOS development delivering sleek, secure, high-performance mobile
                            apps.</p>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="category-card single">
                        <div class="box-img global-img">
                            <img src="assets/img/category/category_1_8.jpg" alt="Logo Design" />
                        </div>
                        <h3 class="box-title"><a routerLink="/design">Logo Design</a></h3>
                        <p class="sec-text">Professional logo design tailored to elevate your brand identity.</p>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="category-card single">
                        <div class="box-img global-img">
                            <img src="assets/img/category/category_1_7.jpg" alt="Cloud Integration" />
                        </div>
                        <h3 class="box-title"><a routerLink="/services">Cloud Integration</a></h3>
                        <p class="sec-text">Around-the-clock monitoring and troubleshooting.</p>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="category-card single">
                        <div class="box-img global-img">
                            <img src="assets/img/category/category_1_1.jpg" alt="Customized Services" />
                        </div>
                        <h3 class="box-title"><a routerLink="/services">Customized Services</a></h3>
                        <p class="sec-text">Customized services tailored to your unique business needs and goals.</p>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="category-card single">
                        <div class="box-img global-img">
                            <img src="assets/img/category/category_1_9.jpg" alt="24/7 IT Support" />
                        </div>
                        <h3 class="box-title"><a routerLink="/contact">24/7 IT Support</a></h3>
                        <p class="sec-text">Reliable 24/7 IT support to keep your business running smoothly.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>